//Font action
import { ShortEventStatusActionTypes, AddEventStatuses, ModifyEventStatuses, DeleteEventStatuses  } from 'Actions/ActionTypes';
import { ShortEventStatus, Id } from 'NSwag/ServerClient/Client.nswag';

export const addEventStatuses = (eventStatuses: ShortEventStatus[]): AddEventStatuses => ({
    type: ShortEventStatusActionTypes.AddEventStatuses as ShortEventStatusActionTypes.AddEventStatuses,
    eventStatuses
});

export const modifyEventStatuses = (eventStatuses: ShortEventStatus[]): ModifyEventStatuses => ({
    type: ShortEventStatusActionTypes.ModifyEventStatuses as ShortEventStatusActionTypes.ModifyEventStatuses,
    eventStatuses
});

export const deleteEventStatuses = (ids: Id[]): DeleteEventStatuses => ({
    type: ShortEventStatusActionTypes.DeleteEventStatuses as ShortEventStatusActionTypes.DeleteEventStatuses,
    ids
});

export type ShortEventStatusAction = ReturnType<typeof addEventStatuses | typeof modifyEventStatuses | typeof deleteEventStatuses >